import React from 'react';
import DashboardLayout from '../components/dashboard/DashboardLayout';

/**
 * PurposeDashboard - 目的ベースダッシュボードページ
 * 
 * 263行 → 15行に圧縮（DashboardLayout共通化により）
 */
function PurposeDashboard() {
    return (
        <DashboardLayout
            variant="purpose"
            seoProps={{
                title: '目的ベースダッシュボード | 高山市AIカメラデータ',
                description: '高山市のAIカメラから取得した歩行者オープンデータを活用。観光地の混雑状況を可視化し、事業者に「やりたいこと」を与え、悩みを解決します。',
                keywords: '高山市,ダッシュボード,観光,混雑度,混雑状況,データ可視化,オープンデータ,データ分析,事業者支援,飛騨高山,MDG,遠藤・浦田研究室,目的ベース',
                url: 'https://ai-camera.lab.mdg-meidai.com/purpose',
            }}
        />
    );
}

export default PurposeDashboard;
